@if (digitalProperty) {
  <div class="row">
    <div class="col-12" [ngClass]="{ 'col-md-12': !modal }">
      <div class="row">
        <div [ngClass]="{ 'col-md-8': !modal }">
          @if (form) {
            <form [formGroup]="form" (submit)="debouncedSubmitAction()">
              <fieldset>
                <legend class="visuallyhidden">{{ 'digital_property_form' | translate }}</legend>

                <app-common-input
                  [form]="form"
                  [formValidationRequest$]="formValidationRequest$"
                  [context]="{ field: $digitalProperty.workspace, label: 'digital_workspace_label' }"
                ></app-common-input>

                <div class="row my-4">
                  <div class="col-12">
                    <app-common-input
                      [form]="form"
                      [formValidationRequest$]="formValidationRequest$"
                      [context]="{ field: $digitalProperty.name, label: 'digital_name_label' }"
                    ></app-common-input>
                    <app-form-field-char-count
                      [field]="form.get($digitalProperty.name)"
                      [charLimit]="charLimits[$digitalProperty.name]"
                    ></app-form-field-char-count>
                  </div>
                </div>

                @if (tagsFeatureEnabled) {
                  <app-multiselect-typeahead
                    label="tags"
                    formControlName="tags"
                    [form]="form"
                    [allowCustomValues]="true"
                    [maxValues]="maxDigitalTag"
                    [maxValueLength]="maxDigitalTagCharLength"
                    [description]="'type_and_press_enter_tag' | translate"
                    [isAlphanumericValidationEnabled]="true"
                  ></app-multiselect-typeahead>
                }
                @if (isMobile) {
                  <app-common-input
                    [form]="form"
                    [formValidationRequest$]="formValidationRequest$"
                    [context]="{
                      field: $digitalProperty.mobileBundleId,
                      label: 'mobile_bundle_id_label',
                      description: 'mobile_bundle_id_description',
                    }"
                  ></app-common-input>
                  @if (isAdminView && (canUpdateDigitalProperties$ | async)) {
                    <div class="row form-row">
                      <div class="col-12 d-flex align-items-center">
                        <input
                          type="checkbox"
                          id="noBundleIdRestriction"
                          name="noBundleIdRestriction"
                          [formControlName]="$digitalProperty.noBundleIdRestriction"
                        />
                        <label for="noBundleIdRestriction" class="label font-normal ms-2">
                          {{ 'no_bundle_id_restriction' | translate }}
                        </label>
                      </div>
                    </div>
                  }
                }

                @if (showWebsiteFields) {
                  <app-common-input
                    [form]="form"
                    [formValidationRequest$]="formValidationRequest$"
                    [context]="{
                      field: $digitalProperty.url,
                      label: 'digital_url_label',
                      required: isDomainRestrictionSupported(),
                    }"
                  ></app-common-input>
                }

                <app-common-input
                  [form]="form"
                  [formValidationRequest$]="formValidationRequest$"
                  [context]="{ field: $digitalProperty.propertyKey, label: 'digital_property_key_label' }"
                ></app-common-input>

                @if (showWebsiteFields) {
                  <app-common-input
                    [form]="form"
                    [formValidationRequest$]="formValidationRequest$"
                    [context]="{ field: $digitalProperty.pagesLimit, label: 'label_monitoring_page_limit', type: 'number' }"
                  ></app-common-input>

                  <app-common-input
                    [formValidationRequest$]="formValidationRequest$"
                    [form]="form"
                    [context]="{
                      label: 'extra_swa_wait_time',
                      field: $digitalProperty.extraSwaWait,
                      required: false,
                    }"
                  >
                  </app-common-input>

                  <div class="row form-row" [hidden]="!isDomainRestrictionSupported()">
                    <div class="col-md-3 col-12 d-flex align-items-center">
                      <label for="digital-property-no-domain-restriction">{{ 'digital_restrictions_label' | translate }}</label>
                    </div>
                    <div class="row col-md-9 col-12">
                      <div class="col-1 pe-0 permission-checkbox">
                        <input
                          type="checkbox"
                          id="digital-property-no-domain-restriction"
                          name="digital-property-no-domain-restriction"
                          [formControlName]="$digitalProperty.noDomainRestrictions"
                          class="form-element w-100"
                        />
                      </div>
                      <div class="col-11 ps-0">
                        <label for="digital-property-no-domain-restriction">
                          {{ 'digital_property_no_domain_restriction' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div [hidden]="!isDomainRestrictionSupported()" class="row form-row">
                    <div class="col-md-9 offset-md-3">
                      <div class="row">
                        <div class="col-md-12 d-flex align-items-center">
                          <label for="authorizedDomains">{{ 'label_authorized_domains' | translate }}</label>
                          <svg
                            viewBox="0 0 8 8"
                            appTooltip="{{ 'authorized_domains_description' | translate }}"
                            class="open-icon open-icon-primary margin-left-xs"
                            [attr.aria-label]="'authorized_domains_description' | translate"
                          >
                            <use xlink:href="#question-mark-2"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <textarea
                            placeholder="{{ 'placeholder_authorized_domains' | translate }}"
                            id="authorizedDomains"
                            name="authorizedDomains"
                            rows="5"
                            [formControlName]="$digitalProperty.authorizedDomains"
                            class="form-element w-100"
                          ></textarea>
                        </div>
                        <div class="col-md-12" aria-live="polite" role="status" id="domainErrors">
                          @if (form.disabled === false) {
                            <app-form-field-error
                              [formValidationRequest$]="formValidationRequest$"
                              [field]="form.controls[$digitalProperty.authorizedDomains]"
                              [name]="$digitalProperty.authorizedDomains"
                              [label]="'label_authorized_domains'"
                            ></app-form-field-error>
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  <app-common-select
                    class="d-block margin-bottom"
                    [formValidationRequest$]="formValidationRequest$"
                    [values]="auditToolSelectOptions"
                    [form]="form"
                    [context]="{
                      label: 'digital_default_tool_label',
                      field: $digitalProperty.defaultTool,
                      valueKey: 'value',
                      nameKey: 'displayName',
                      tooltip: 'digital_default_tool_tooltip',
                    }"
                  ></app-common-select>

                  <div class="row form-row">
                    <div class="col-12">
                      <div id="contain-accessibility-statement" class="label margin-bottom-xs text-nowrap">
                        {{ 'contain_digital_accessibility_statement_label' | translate }}
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div
                            class="d-flex flex-column align-items-start btn-group"
                            role="radiogroup"
                            aria-labelledby="contain-accessibility-statement"
                          >
                            <label
                              class="clean-button button-no btn border-0"
                              [class.active]="hasAccessibilityStatement === false"
                            >
                              <input
                                type="radio"
                                [(ngModel)]="hasAccessibilityStatement"
                                [ngModelOptions]="{ standalone: true }"
                                [value]="false"
                                (ngModelChange)="onAccessibilityStatementSelectorChange($event)"
                              />
                              {{ 'no' | translate }}
                            </label>
                            <label
                              class="clean-button button-yes btn border-0"
                              [class.active]="hasAccessibilityStatement === true"
                            >
                              <input
                                type="radio"
                                [(ngModel)]="hasAccessibilityStatement"
                                [ngModelOptions]="{ standalone: true }"
                                [value]="true"
                                (ngModelChange)="onAccessibilityStatementSelectorChange($event)"
                              />
                              {{ 'yes' | translate }}
                            </label>
                          </div>
                        </div>
                      </div>
                      @if (hasAccessibilityStatement) {
                        <app-common-input
                          class="d-block margin-bottom"
                          [formValidationRequest$]="formValidationRequest$"
                          [form]="form"
                          [context]="{
                            label: 'digital_accessibility_statement_label',
                            field: $digitalProperty.accessibilityStatement,
                          }"
                        ></app-common-input>
                      }
                    </div>
                  </div>

                  @if (digitalAssetsPrivacySettingFeatureEnabled) {
                    <app-confidential-scanning-switch
                      [value]="form.get($digitalProperty.privacyObfuscationEnabled)?.value"
                      [disabled]="confidentialScanningEnabledTenantLevel"
                      [tooltip]="confidentialScanningTooltip"
                      (valueChange)="form.get($digitalProperty.privacyObfuscationEnabled)?.setValue($event)"
                    ></app-confidential-scanning-switch>
                  }

                  <app-scanning-agent-switch
                    [value]="form.get($digitalProperty.useScanningAgent)?.value"
                    (valueChange)="form.get($digitalProperty.useScanningAgent)?.setValue($event)"
                  ></app-scanning-agent-switch>
                }

                @if (showWebsiteFields && contentsquareIntegrationFeatureEnabled) {
                  <div class="margin-top row form-row">
                    <div class="col-12">
                      <app-toggle-switch
                        [name]="'contentsquare-integration-toggle'"
                        [id]="'contentsquare-integration-toggle'"
                        [value]="form.get($digitalProperty.contentsquareIntegration)?.value"
                        (valueChange)="form.get($digitalProperty.contentsquareIntegration)?.setValue($event)"
                        class="d-flex justify-content-between"
                        [attr.aria-describedby]="'contentsquare-integration-description'"
                      >
                        <span class="switch-label">
                          {{ 'contentsquare_integration_label' | translate }}
                        </span>
                      </app-toggle-switch>
                      <span id="contentsquare-integration-description" class="small">{{
                        'contentsquare_integration_description' | translate
                      }}</span>
                    </div>
                  </div>
                }
              </fieldset>

              <div class="row form-row mt-4">
                <div class="col-md-12" [ngClass]="{ 'text-end': !modal, 'd-flex': modal, 'gap-3': modal }">
                  <button
                    ds-button
                    [variant]="DsButtonVariants.primary"
                    type="submit"
                    [ngClass]="{ 'margin-left': !modal }"
                    [disabled]="form.disabled"
                  >
                    {{ 'digital_property_action_update' | translate }}
                  </button>
                  @if (modal) {
                    <button
                      ds-button
                      [variant]="DsButtonVariants.secondary"
                      type="button"
                      (click)="onCancel()"
                      data-test-id="cancel-button"
                    >
                      {{ 'label_cancel' | translate }}
                    </button>
                  }
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    </div>
  </div>
}
